export const disabledOgImagePages = [
  '/DYNAMIC_PAGES/guided-motorcycle-tours/_tour_slug',
  '/DYNAMIC_PAGES/self-drive-motorcycle-tours/_tour_slug',
];
